import { isEmpty, uniq, isNil } from "lodash";
import qs from "qs";

export { pick, isNil } from "lodash";
/* eslint-disable import/prefer-default-export */
/**
 * 通过身份证号获取年龄
 * @param {number} idcard 身份证号
 */
export const getAgeFromIdCard = (idcard) => {
  if (!idcard || idcard.length < 10) return;

  const birthYear = String(idcard).slice(6, 10);
  const currentYear = new Date().getFullYear();
  const age = currentYear - birthYear;
  return age < 0 ? 0 : age;
};

export const convertEnumValue = (value) => {
  if (isEmpty(value)) return;
  return {
    text: value,
    value,
  };
};

export const includes = (arr, target) => {
  if (isEmpty(arr) || isEmpty(target) || !Array.isArray(arr)) {
    return false;
  }
  let result = false;
  const targetArr = target.split(",");
  result = arr.some(
    (item) =>
      item &&
      (targetArr.indexOf(item) > -1 || targetArr.indexOf(item.value) > -1)
  );
  return result;
};

export const convertDateValue = (date) => {
  let result;
  try {
    result =
      new Date(Date.parse(date.replace(/\//g, "-"))).setHours(0) ||
      new Date(Date.parse(date.replace(/\-/g, "/"))).setHours(0);
  } catch (e) {
    console.warn("dateFormat format error");
  }
  return isNaN(result) ? date : result;
};

export const chainGetVal = (...values) => {
  return values.reduce((res, cur) => {
    if (!(cur in res)) {
      throw new Error(`${JSON.stringify(cur)} not in ${JSON.stringify(res)}`);
    }
    return res[cur];
  });
};

export const objectSpread = (...objs) => {
  return objs.reduce((res, cur) => {
    return { ...res, ...cur };
  });
};

export const arraySpread = (...arrays) => {
  return arrays.reduce((res, cur) => {
    return [...res, ...cur];
  });
};

export const pickValues = (arr, key = "value", delimiter = ",") => {
  if (isEmpty(arr)) {
    return "";
  }
  return arr.map((item) => item[key]).join(delimiter);
};

export const now = () => {
  return new Date().getTime();
};

export const getUrlParams = () => {
  return qs.parse(location.href.toString().split("?")[1]);
};

export const getOptionsFromTableData = (tableData, key) => {
  if (isEmpty(tableData)) return [];
  const dataArr = tableData
    .map((item) => item[key])
    .filter((item) => !isNil(item));
  return uniq(dataArr).map((item) => ({
    text: item,
    value: item,
  }));
};
